const http = require('../lib/httpClient');
const { getChannelId, getXCommerceValue } = require('../lib/browserData');
const { getEcommId } = require('../lib/browserData');

const { decodeJWT } = require('../utils/decoder');
const { COMMERCE_HEADER } = require('../constants');

const agentLoginError = {
  code: 'AGENT_LOGIN_ERROR',
  message: 'Unable to login',
};

const loginEndpoint = '/s/auth/v1/agent/login';

async function agentLogin(
  adfsAccessToken,
  adfsRefreshToken,
  adfsIdToken,
  // eslint-disable-next-line default-param-last
  customInfo = [],
  tenantId,
  agentBaseUrl = '',
  additionalInfo = {},
) {
  const result = await http.post(
    `${agentBaseUrl}${loginEndpoint}`,
    {
      idToken: adfsIdToken,
      refreshToken: adfsRefreshToken,
      customInfo,
    },
    {
      headers: {
        Authorization: `Bearer ${adfsAccessToken}`,
        'x-channel-id': getChannelId(),
        'x-ecomm-name': getEcommId(tenantId, additionalInfo),
        'x-commerce': getXCommerceValue(agentBaseUrl) || COMMERCE_HEADER,
      },
    },
  );

  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [agentLoginError] };
  const { idToken: sessionJWT, errors } = responseBody;
  if (errors) return { data: undefined, errors };
  const sessionData = decodeJWT(sessionJWT);
  const { session: { status: sessionStatus } = {} } = sessionData;
  if (sessionStatus !== 'Authenticated') {
    return {
      data: undefined,
      errors: [
        {
          code: 'LOGIN_ERROR_NON_HARD_LOGIN',
          message: 'User not hard logged in',
        },
      ],
    };
  }

  return { data: { ...responseBody, ...sessionData }, errors: [] };
}

module.exports = agentLogin;
